import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";

/**
 * Message composition fields — subject, heading, body, CTA label/URL.
 * Pure presentational; parent owns `form` + `setForm`.
 */
export default function BroadcastComposeForm({ form, onChange }) {
  const set = (patch) => onChange({ ...form, ...patch });
  return (
    <div className="space-y-3">
      <div>
        <label className="text-xs uppercase tracking-widest text-zinc-500">Subject</label>
        <Input
          value={form.subject}
          onChange={(e) => set({ subject: e.target.value })}
          className="mt-1 bg-black/40 border-white/10 rounded-none py-5"
          data-testid="broadcast-subject"
        />
      </div>
      <div>
        <label className="text-xs uppercase tracking-widest text-zinc-500">Heading</label>
        <Input
          value={form.heading}
          onChange={(e) => set({ heading: e.target.value })}
          className="mt-1 bg-black/40 border-white/10 rounded-none py-5"
          data-testid="broadcast-heading"
        />
      </div>
      <div>
        <label className="text-xs uppercase tracking-widest text-zinc-500">
          Body (blank line = new paragraph)
        </label>
        <Textarea
          value={form.body}
          onChange={(e) => set({ body: e.target.value })}
          rows={7}
          className="mt-1 bg-black/40 border-white/10 rounded-none focus-visible:ring-rose-600"
          data-testid="broadcast-body"
        />
      </div>
      <div className="grid grid-cols-2 gap-3">
        <div>
          <label className="text-xs uppercase tracking-widest text-zinc-500">Button label</label>
          <Input
            value={form.cta_label || ""}
            onChange={(e) => set({ cta_label: e.target.value })}
            className="mt-1 bg-black/40 border-white/10 rounded-none py-5"
          />
        </div>
        <div>
          <label className="text-xs uppercase tracking-widest text-zinc-500">Button URL</label>
          <Input
            value={form.cta_url || ""}
            onChange={(e) => set({ cta_url: e.target.value })}
            className="mt-1 bg-black/40 border-white/10 rounded-none py-5"
          />
        </div>
      </div>
    </div>
  );
}
